import { ConnectorFormDetails, Input, Label } from "@simplicity/ui";
import { TablesEditor, type Schedules, type TableConfig } from "../tables";
import type { ConnectorFormProps } from "./GenericVarsForm";

export function PSEnrollmentForm(props: ConnectorFormProps) {
  const tables = Array.isArray(props.vars.tables) ? (props.vars.tables as TableConfig[]) : [];
  const schedules = (
    props.vars.schedules != null &&
    typeof props.vars.schedules === "object" &&
    !Array.isArray(props.vars.schedules)
      ? props.vars.schedules
      : {}
  ) as Schedules;

  const bronzeDataset = (props.vars.bronzeDataset as string) ?? "";
  const silverDataset = (props.vars.silverDataset as string) ?? "";

  function updateField(key: string, value: string) {
    const next = { ...props.vars };
    if (value) {
      next[key] = value;
    } else {
      delete next[key];
    }
    props.onVarsChange(next);
    props.clearBanner();
  }

  return (
    <>
      <TablesEditor
        tables={tables}
        schedules={schedules}
        onChange={(change) => {
          props.onVarsChange({ ...props.vars, ...change });
          props.clearBanner();
        }}
        connectorType={props.connectorType}
        connectorId={props.connectorId}
      />
      {!props.hideAdvanced && (
        <ConnectorFormDetails
          summary="Advanced Options"
          className="mt-4 rounded border border-border/50"
        >
          <div className="flex gap-4">
            <div className="flex-1">
              <Label htmlFor="pse-bronze-dataset" className="form-label">
                Bronze Dataset
              </Label>
              <Input
                id="pse-bronze-dataset"
                type="text"
                value={bronzeDataset}
                onChange={(e) => updateField("bronzeDataset", e.target.value)}
                placeholder={`Default: bronze__${props.connectorPrefix}`}
                className="font-mono"
              />
            </div>
            <div className="flex-1">
              <Label htmlFor="pse-silver-dataset" className="form-label">
                Silver Dataset
              </Label>
              <Input
                id="pse-silver-dataset"
                type="text"
                value={silverDataset}
                onChange={(e) => updateField("silverDataset", e.target.value)}
                placeholder={`Default: silver__${props.connectorPrefix}`}
                className="font-mono"
              />
            </div>
          </div>
        </ConnectorFormDetails>
      )}
    </>
  );
}
